/** Design canvas size matching portrait kiosk (make-a-wish / creative studio). */
export const PORTRAIT_WIDTH = 800;
export const PORTRAIT_HEIGHT = 1280;

export const PORTRAIT_STAGE_ID = 'portrait-stage';
export const PORTRAIT_VIEWPORT_ID = 'portrait-viewport';

export const getPortraitViewportContainer = () =>
  document.getElementById(PORTRAIT_VIEWPORT_ID);

export const getPortraitStageContainer = () =>
  document.getElementById(PORTRAIT_STAGE_ID);

/** Full-viewport stage over fixed gallery background. */
function PortraitStage({ children, className = '' }) {
  return (
    <>
      <div className="appBg" aria-hidden="true" />
      <div
        id={PORTRAIT_VIEWPORT_ID}
        className={`portraitViewport ${className}`.trim()}
      >
        <div id={PORTRAIT_STAGE_ID} className="portraitStage">
          {children}
        </div>
      </div>
    </>
  );
}

export default PortraitStage;
